export default __webpack_public_path__ + "static/media/CIENCIAS DO DESPORT PDF.94b2fb20.pdf";